import './internal/vg';

import Type from './lib/type';
import Browser from './lib/browser';
import Text from './lib/text';

export {
    Type,
    Browser,
    Text
};


export * from './core-compatibility';

if (global && global.window && global.window.VG)
{
    Object.assign(global.window.VG, exports);
}